<div style="padding: 16px;">
  <cs-label style="display: block; margin-bottom: 12px;">Text-only tabs:</cs-label>
  <cs-tab [(selection)]="selectedTab">
    <cs-tab-button value="tab1">
      <cs-label>Tab 1</cs-label>
    </cs-tab-button>
    <cs-tab-button value="tab2">
      <cs-label>Tab 2</cs-label>
    </cs-tab-button>
    <cs-tab-button value="tab3">
      <cs-label>Tab 3</cs-label>
    </cs-tab-button>
    <cs-tab-button value="tab4">
      <cs-label>Tab 4</cs-label>
    </cs-tab-button>
  </cs-tab>

  <cs-label style="display: block; margin: 24px 0 12px;">Tabs with icons (like Foods page):</cs-label>
  <cs-tab [(selection)]="selectedIconTab">
    <cs-tab-button value="all">
      <cs-label>All</cs-label>
    </cs-tab-button>
    <cs-tab-button value="foods">
      <cs-icon name="food"></cs-icon>
      <cs-label>Foods</cs-label>
    </cs-tab-button>
    <cs-tab-button value="recipes">
      <cs-icon name="recipe"></cs-icon>
      <cs-label>Recipes</cs-label>
    </cs-tab-button>
    <cs-tab-button value="meals">
      <cs-icon name="meal"></cs-icon>
      <cs-label>Meals</cs-label>
    </cs-tab-button>
    <cs-tab-button value="favorites">
      <cs-icon name="liked"></cs-icon>
      <cs-label>Favorites</cs-label>
    </cs-tab-button>
  </cs-tab>

  <cs-label style="display: block; margin: 24px 0 12px;">Selected values:</cs-label>
  <cs-item-list>
    <cs-item>
      <cs-label>Text tabs:</cs-label>
      <cs-label class="mono">{{ selectedTab }}</cs-label>
    </cs-item>
    <cs-item>
      <cs-label>Icon tabs:</cs-label>
      <cs-label class="mono">{{ selectedIconTab }}</cs-label>
    </cs-item>
  </cs-item-list>
</div>
